import './B2BButtonGroup.css';

import React, { useState } from 'react';
import { ButtonGroup, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { generateClassName } from './helpers';

const B2BButtonGroup = ({ buttonConfigs, className = null }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSubMenu, setCurrentSubMenu] = useState(null);

    const handleClick = (event, config) => {
        if (config.subMenu) {
            setAnchorEl(event.currentTarget);
            setCurrentSubMenu(config.subMenu);
        } else {
            config.onClick();
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
        setCurrentSubMenu(null);
    };

    const anyItemHasIcon = currentSubMenu?.some(item => item.icon !== undefined);

    return (
        <>
            <ButtonGroup size="small" aria-label="small button group" className={generateClassName("b2b-default", "-button-group", className)}>
                {buttonConfigs.map((config, index) => (
                    <IconButton
                        key={index}
                        onClick={(event) => handleClick(event, config)}
                        className={`${generateClassName("b2b-default-button-group", "-button", className)} ${config.className}`}
                    >
                        {config.icon}
                        <Typography variant="body2" className={generateClassName("b2b-default-button-group", "-button-label", className)}>
                            {config.label}
                        </Typography>
                    </IconButton>
                ))}
            </ButtonGroup>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className={generateClassName("b2b-default-button-group", "-submenu", className)}
            >
                {currentSubMenu?.map((item) => (
                    <MenuItem
                        key={item.key}
                        onClick={item.onClick}
                        className={generateClassName("b2b-default-button-group-submenu", "-menuitem", className)}
                    >
                        {anyItemHasIcon && (
                            <div className={generateClassName("b2b-default-button-group-submenu", "-menuitem-icon", className)}>
                                {item.icon || null}
                            </div>
                        )}
                        <div className={generateClassName("b2b-default-button-group-submenu", "-menuitem-label", className)}>
                            {item.label}
                        </div>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default B2BButtonGroup;
